import cn from 'classnames'
import React, { ComponentProps } from 'react'

type CardsNewIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function CardsNewIcon(props: CardsNewIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('CardsNewIcon', className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M2.40002 8.91428V6.8C2.40002 5.69543 3.29545 4.8 4.40002 4.8H19.6C20.7046 4.8 21.6 5.69543 21.6 6.8V8.91428M2.40002 8.91428H21.6M2.40002 8.91428L2.40002 17.2C2.40002 18.3046 3.29545 19.2 4.40002 19.2H19.6C20.7046 19.2 21.6 18.3046 21.6 17.2V8.91428M13.032 14.9647H17.76"
        stroke="#697080"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
